/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_shipmentQuote = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbShipping_shipmentQuote">;
    readonly " $refType": "PdpRespSidebarBlurbs_shipmentQuote";
};
export type PdpRespSidebarBlurbs_shipmentQuote$data = PdpRespSidebarBlurbs_shipmentQuote;
export type PdpRespSidebarBlurbs_shipmentQuote$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_shipmentQuote$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_shipmentQuote">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_shipmentQuote",
  "type": "ShipmentQuote",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_shipmentQuote",
      "args": null
    }
  ]
};
(node as any).hash = '85984b8f55bab7b2541761aca530b253';
export default node;
